import {
  Info as Icon
} from 'components/icons';

export const meta = {
  id: 'Tenants',
  title: 'Tenants',
  category: '',
  // exposes: [
  //   {
  //     title: 'Tenants',
  //     action: { module: 'Tenants', props: { /* */ } },
  //   },
  //   {
  //     title: 'New Tenants',
  //     action: { module: 'TenantsDetails', props: { context: 'add' } },
  //   },
  // ],
  unique: false,
  icon: Icon,
  version: '1.0.0',
  description: `The tenants CRUD manager module`,
  windowOptions: {
    // if not passed, will be centered
    // x: null,
    // y: null,
    // width: 630,
    // height: 380
  }
};
